import localizationStrings from "../../statics/localization";

const copy = {
  eng: {
    eyebrow: "THE WORLD OF ATLAS",
    storyLabel: "Welcome back to Atlas",
    storyTitle: "Your next story.",
    storyAccent: "Still waiting for you.",
    storyNote:
      "A small reset, then back to the films, series and moments you love.",
    cardEyebrow: "ACCOUNT RECOVERY",
    title: "Forgot your password?",
    note: "Enter the email address linked to your account. We’ll help you set a new password.",
    email: "Email address",
    placeholder: "you@example.com",
    required: "Enter your email address.",
    invalid: "Enter a valid email address.",
    submit: "Send reset link",
    sending: "Sending your link…",
    back: "Back to sign in",
    hint: "You’ll choose your new password using the link in your email.",
    error: "We couldn’t complete your request. Please try again.",
    offline: "You’re offline. Check your connection and try again.",
    retry: "Try again",
    sentEyebrow: "ONE STEP CLOSER",
    sentTitle: "Check your inbox.",
    sentNote:
      "If an account is linked to this address, you’ll receive an email with instructions to reset your password.",
    spamHint: "Can’t see it yet? Give it a moment and check your spam folder.",
    anotherEmail: "Use a different email address",
    signature: "EVERY STORY. A NEW WORLD."
  },
  tr: {
    eyebrow: "ATLAS DÜNYASI",
    storyLabel: "Atlas’a yeniden hoş geldin",
    storyTitle: "Sıradaki hikâyen.",
    storyAccent: "Seni bekliyor.",
    storyNote:
      "Küçük bir yenilik, ardından sevdiğin filmlere, dizilere ve anlara dönüş.",
    cardEyebrow: "HESABINA YENİDEN ERİŞ",
    title: "Şifreni mi unuttun?",
    note: "Hesabına bağlı e-posta adresini gir. Yeni bir şifre belirlemene yardımcı olalım.",
    email: "E-posta adresi",
    placeholder: "ornek@eposta.com",
    required: "E-posta adresini gir.",
    invalid: "Geçerli bir e-posta adresi gir.",
    submit: "Yenileme bağlantısı gönder",
    sending: "Bağlantın gönderiliyor…",
    back: "Girişe dön",
    hint: "Yeni şifreni e-postandaki bağlantı üzerinden belirleyebilirsin.",
    error: "İsteğini tamamlayamadık. Lütfen tekrar dene.",
    offline: "İnternet bağlantın yok. Bağlantını kontrol edip tekrar dene.",
    retry: "Tekrar dene",
    sentEyebrow: "BİR ADIM KALDI",
    sentTitle: "E-postanı kontrol et.",
    sentNote:
      "Bu adrese bağlı bir hesap varsa, şifreni yenilemek için gerekli adımları e-posta ile alacaksın.",
    spamHint: "Henüz gelmedi mi? Biraz bekle ve spam klasörünü de kontrol et.",
    anotherEmail: "Farklı bir e-posta adresi kullan",
    signature: "HER HİKÂYE. YENİ BİR DÜNYA."
  },
  arb: {
    eyebrow: "عالم أطلس",
    storyLabel: "مرحباً بعودتك إلى أطلس",
    storyTitle: "قصتك التالية.",
    storyAccent: "لا تزال بانتظارك.",
    storyNote:
      "خطوة بسيطة، ثم العودة إلى الأفلام والمسلسلات واللحظات التي تحبها.",
    cardEyebrow: "استعادة الحساب",
    title: "نسيت كلمة المرور؟",
    note: "أدخل البريد الإلكتروني المرتبط بحسابك. سنساعدك على تعيين كلمة مرور جديدة.",
    email: "البريد الإلكتروني",
    placeholder: "you@example.com",
    required: "أدخل بريدك الإلكتروني.",
    invalid: "أدخل بريداً إلكترونياً صالحاً.",
    submit: "إرسال رابط إعادة التعيين",
    sending: "جارٍ إرسال الرابط…",
    back: "العودة لتسجيل الدخول",
    hint: "يمكنك تعيين كلمة مرور جديدة عبر الرابط في بريدك الإلكتروني.",
    error: "تعذر إكمال طلبك. حاول مرة أخرى.",
    offline: "أنت غير متصل بالإنترنت. تحقق من اتصالك وحاول مرة أخرى.",
    retry: "إعادة المحاولة",
    sentEyebrow: "بقيت خطوة واحدة",
    sentTitle: "تحقق من بريدك.",
    sentNote:
      "إذا كان هناك حساب مرتبط بهذا العنوان، فستتلقى رسالة تتضمن تعليمات إعادة تعيين كلمة المرور.",
    spamHint:
      "لم تصل الرسالة بعد؟ انتظر قليلاً وتحقق من مجلد البريد غير المرغوب فيه.",
    anotherEmail: "استخدام بريد إلكتروني آخر",
    signature: "كل قصة. عالم جديد."
  }
};

export const getRecoveryCopy = () =>
  copy[localizationStrings.getLanguage()] || copy.eng;
